import React, { Component } from 'react';

import { Helmet } from 'react-helmet';
import TextBlock from 'components/TextBlock/TextBlock';
import BlogGrid from 'components/BlogGrid/BlogGrid';
import Rellax from 'rellax';

import { I18n } from 'react-i18next';
import i18n from '../i18n';

export default class Blog extends Component {
  componentDidMount() {
    new Rellax('.parallax-logo', {
      speed: 4,
      center: false,
      round: true,
      vertical: true,
      horizontal: false,
    });
  }

  render() {
    return [
      <I18n>
        {(t, { i18n }) => (
          <Helmet key='head'>
            <meta charSet='utf-8' />
            <title>Blog | Forever Plants | Ontdek waar FPG voor staat</title>
            <meta property='og:image' />
            <meta
              name='blog'
              content='We vertellen graag over onszelf. Nog liever vertellen we over waar Forever Plants Group voor staat en wat we willen bereiken met de planten die we grootbrengen. Lees hier alles over het groener maken van woonkamers, bedrijven, levens en uiteindelijk ook de hele wereld. Ambitieus? Zeker. Onmogelijk? Niet als jij ook meehelpt.'
            />
            <meta
              property='og:description'
              content='We vertellen graag over onszelf. Nog liever vertellen we over waar Forever Plants Group voor staat en wat we willen bereiken met de planten die we grootbrengen. Lees hier alles over het groener maken van woonkamers, bedrijven, levens en uiteindelijk ook de hele wereld. Ambitieus? Zeker. Onmogelijk? Niet als jij ook meehelpt.'
            />
          </Helmet>
        )}
      </I18n>,
      <span className='parallax-logo' key='logo' />,
      <I18n>
        {(t, { i18n }) => (
          <main id='pageWrapper' key='content'>
            <div style={{ position: 'relative' }}>
              <div className='wrapper mt24'>
                <TextBlock
                  title={t('blogTitle')}
                  subtitle={t('blogSubTitle')}
                />
                <BlogGrid />
                {/* <TextBlock
                  extraClasses="mt80 mb32"
                  title={t('blogSliderTitle')}
                />
                <InstaFeed /> */}
              </div>
              <span className='blogFlower-pageEnd' key='logo' />
            </div>
          </main>
        )}
      </I18n>,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/Pages/Blog.jsx